//// <copyright file="share-to-meeting.jsx" company="Microsoft Corporation">
//// Copyright (c) Microsoft Corporation.
//// Licensed under the MIT license.
//// </copyright>

//import React, { useEffect } from "react";

//// Default browser page from where content can directly shared to meeting.
//const ShareToMeeting = props => {

//    useEffect(() => {
//        const script = document.createElement("script");
//        script.src = "https://teams.microsoft.com/share/launcher.js";
//        document.body.appendChild(script);
//    }, []);

//    return (
//        <>
//		    <div class="surface">
//                <h3 id="tabheader"> Welcome Meeting Tab</h3>
//		    </div>
//		</>
//    );
//};

//export default ShareToMeeting;


import React, { useEffect, useState } from "react";
import * as microsoftTeams from "@microsoft/teams-js";
import UsageLogService from "../services/UsageLogService";

const ShareToMeeting = () => {
    const [ctx, setCtx] = useState(null);

    useEffect(() => {
        microsoftTeams.app.initialize().then(async () => {
            const context = await microsoftTeams.app.getContext();
            setCtx(context);
            microsoftTeams.app.notifySuccess();
        });
    }, []);

    // Track page view for analytics
    useEffect(() => {
        microsoftTeams.app.getContext().then((context) => {
            UsageLogService.trackPageView('ShareToMeeting', {
                inMeeting: !!context.meeting
            });
        });
    }, []);

    return (
        <div style={{ padding: 16 }}>
            <h3>Welcome to Spark Anywhere</h3>
            <p>
                To use this app, Access it from Teams side panel tab:
                <br />
                <b>Apps → Spark Assist → Add</b>
            </p>

            <div style={{ marginTop: 12, fontSize: 12, opacity: 0.8 }}>
                <div><b>Host:</b> {window.location.origin}</div>
                <div><b>In meeting:</b> {ctx?.meeting ? "Yes" : "No"}</div>
            </div>
        </div>
    );
};

export default ShareToMeeting;
